export const containsEmailAddress = (data: string) => new RegExp(/\b[\w.-]+@[\w.-]+\.\w{2,4}\b/gi).test(data)
